export default __webpack_public_path__ + "static/media/wrongIcon.9dd0d15e.svg";